// extracted by mini-css-extract-plugin
export var sliderRange = "_s0-2";
export var sliderRoot = "_s0-0";
export var sliderThumb = "_s0-3";
export var sliderTrack = "_s0-1";